"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_icons_1 = require("@grandlinex/react-icons");
const util_1 = require("../../util");
const hooks_1 = require("../../util/hooks");
const DropDownIconMenu = (props) => {
    const { menu, left, children, className, onChange, initialValue, isSubMenu, top, } = props;
    const [active, setActive] = (0, react_1.useState)(initialValue ?? {});
    const [height, setHeight] = (0, react_1.useState)(0);
    function closeAll(men) {
        const keys = Object.keys(active).filter((key) => key.startsWith('submenu_'));
        const newActive = { ...active };
        for (const key of keys) {
            newActive[key] = false;
        }
        if (men) {
            newActive[men.key] = men.value;
        }
        setActive(newActive);
    }
    const [menuRef, open, setOpen] = (0, hooks_1.useAutoClose18)({
        extendSearch: 'glx-icon--drop-submenu',
        closeFc: () => {
            closeAll();
        },
    });
    (0, react_1.useEffect)(() => {
        if (menuRef.current && menuRef.current.clientHeight !== height) {
            setHeight(menuRef.current?.clientHeight ?? 0);
        }
    }, [height, menuRef.current, menuRef]);
    return (react_1.default.createElement("div", { className: (0, util_1.cnx)('glx-icon-button-wr', className) },
        react_1.default.createElement("button", { className: "glx-icon-button", onClick: () => setOpen(!open) }, children || (0, react_icons_1.getIcon)('IOEllipsisVertical')({})),
        open ? (react_1.default.createElement("div", { ref: menuRef, style: top ? { top: -height } : undefined, className: (0, util_1.cnx)('glx-icon--drop', [!!left, 'glx-icon--drop--left'], [!!top, 'glx-icon--drop--top'], [!!top && height === 0, 'glx-hidden']) }, menu.map((el) => el.subMenu ? (react_1.default.createElement("div", { className: "glx-icon--drop-submenu" },
            react_1.default.createElement("button", { type: "button", onClick: () => {
                    const k = `submenu_${el.key}`;
                    const v = !active[k];
                    closeAll({ key: k, value: v });
                }, key: el.key },
                el.icon ? (0, react_icons_1.getIcon)(el.icon)({}) : null,
                el.label,
                " ",
                react_1.default.createElement(react_icons_1.IOChevronForward, null)),
            active[`submenu_${el.key}`] ? (react_1.default.createElement("div", { className: (0, util_1.cnx)([!!left, 'glx-icon--drop-submenu-block--left'], [!!top, 'glx-icon--drop-submenu-block--top'], [!left && !top, 'glx-icon--drop-submenu-block']) }, el.subMenu.map((del) => (react_1.default.createElement("button", { type: "button", disabled: del.isLabel, onClick: () => {
                    const v = el.value === undefined
                        ? !active[del.key]
                        : !el.value;
                    del.fc?.();
                    onChange?.(del.key, v);
                    setActive({ ...active, [del.key]: v });
                }, key: del.key },
                del.checkBox ? (react_1.default.createElement("input", { type: "checkbox", checked: del.value ?? (active[del.key] || false) })) : null,
                del.icon ? (0, react_icons_1.getIcon)(del.icon)({}) : null,
                del.label))))) : null)) : (react_1.default.createElement("button", { type: "button", disabled: el.isLabel, onClick: () => {
                const v = el.value === undefined ? !active[el.key] : !el.value;
                el.fc?.();
                onChange?.(el.key, v);
                setActive({ ...active, [el.key]: v });
            }, key: el.key },
            el.checkBox ? (react_1.default.createElement("input", { type: "checkbox", checked: el.value ?? (active[el.key] || false) })) : null,
            el.icon ? (0, react_icons_1.getIcon)(el.icon)({}) : null,
            el.label))))) : null));
};
DropDownIconMenu.defaultProps = {
    left: false,
    top: false,
    onChange: undefined,
    className: undefined,
    initialValue: undefined,
    isSubMenu: false,
    children: undefined,
};
exports.default = DropDownIconMenu;
